<template>
  <v-container fluid class="pa-0 mt-10">
    <div
      :style="{ width: this.$vuetify.display.xlAndUp ? '75%' : '95%' }"
      class="mx-auto"
    >
      <v-row no-gutters class="mb-8" align="center">
        <v-col>
          <h1 class="text-h4 font-weight-bold text-grey-darken-4 mb-2">
            Snippets verwalten
          </h1>
          <p class="text-grey-darken-1 text-body-2">
            Erstellen und bearbeiten Sie Ihre   Snippets
          </p>
        </v-col>
        <v-col cols="auto">
          <v-btn
            color="black"
            variant="tonal"
            @click="openCreateDialog"
            class="text-caption"
            rounded="xl"
            flat
            width="180px"
          >
            <v-icon class="mr-1">mdi-plus</v-icon>
            Neues Snippet
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  name: "Snippets",
  data: () => ({
    snippets: [],
  }),
  components: {},
  mounted() {
    this.getAllSnippets();
  },
  methods: {
    async getAllSnippets() {
      try {
        let result = await axios.get("/api/snippets/get");
        this.snippets = result.data;
      } catch (e) {
        console.error("Fehler beim Laden!", e);
      }
    },
  },
};
</script>
